import { Modal, useModals } from 'almanac-ui/Modal'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Text } from 'blaze-ui/Text/Text'
import { ProviderToName } from 'components/ArticlePostPreview/PostPreviewBody/IntegrationsDrawer/constants'
import { useState } from 'react'

interface PostNowConfirmationModalProps {
  provider: string
  providers?: string[]
  onConfirm: () => Promise<void>
  closeOnResult?: boolean
}

const formatProviderNames = (providers: string[]): string => {
  if (providers.length === 1) {
    return providers[0]
  }
  if (providers.length === 2) {
    return `${providers[0]} and ${providers[1]}`
  }
  return `${providers.slice(0, -1).join(', ')} and ${providers[providers.length - 1]}`
}

export const PostNowConfirmationModal = ({
  provider,
  providers,
  onConfirm,
  closeOnResult = true,
}: PostNowConfirmationModalProps) => {
  const { closeModal } = useModals()
  const [isPosting, setIsPosting] = useState(false)

  const handleConfirm = async () => {
    try {
      setIsPosting(true)
      await onConfirm()
    } finally {
      setIsPosting(false)
      if (closeOnResult) {
        closeModal()
      }
    }
  }

  // Use providers array if available, otherwise fall back to single provider
  // This allows us to pass actual integration names instead of hardcoded channel names
  const providerName = providers
    ? formatProviderNames(providers.map((p) => ProviderToName[p as ExternalIntegrationEnum]))
    : provider

  return (
    <Modal.Root aria-labelledby="modal-heading" size="sm">
      <Modal.Header title="Are you sure you want to post now?" />
      <Modal.Content>
        <Text variant="secondary">Blaze will post the content on your behalf to {providerName}.</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton onPress={closeModal} size="lg" variant="tertiary" isDisabled={isPosting}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={handleConfirm} size="lg" isDisabled={isPosting}>
            {isPosting ? 'Posting...' : 'Post now'}
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
